import { render, staticRenderFns } from "./talent-review.vue?vue&type=template&id=1b7d1bb4&scoped=true&"
import script from "./talent-review.vue?vue&type=script&lang=js&"
export * from "./talent-review.vue?vue&type=script&lang=js&"
import style0 from "./talent-review.vue?vue&type=style&index=0&id=1b7d1bb4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7d1bb4",
  null
  
)

export default component.exports